import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {Link, useParams} from "react-router-dom";
import {getCurrentVendor} from "../../store/reducers/VendorsSlice";
import {
    getCurrentVendorContact,
    getVendorContactRatings,
    getVendorContacts
} from "../../store/reducers/VendorContactsSlice";
import {LoggedInView} from "../common/LoggedInView";
import {VendorContactRatingsTable} from "./components/VendorContactRatingsTable";

interface VendorContactsScreenProps {}

export const VendorContactsRatingsScreen: React.FC<VendorContactsScreenProps> = () => {

    const dispatch = useAppDispatch();
    const {vendorId, contactId} = useParams<{ vendorId: string, contactId: string }>();

    const vendorsState = useAppSelector((state) => state.vendors);
    const vendorContactState = useAppSelector((state) => state.vendorContacts);

    useEffect(() => {
        if (vendorId && contactId) {
            dispatch(getCurrentVendor({ id: vendorId }));
            dispatch(getCurrentVendorContact({ vendorId: parseInt(vendorId, 10), contactId: parseInt(contactId, 10) }));
            dispatch(getVendorContactRatings({ vendorId: parseInt(vendorId, 10), contactId: parseInt(contactId, 10) }));
        }
    }, [contactId, vendorId]);

    return (
        <LoggedInView fullWidth={false}>
            <h1>Hankija {vendorsState?.currentVendor?.name} kontakti {vendorContactState?.currentVendorContact?.name} hinnangud</h1>
            <VendorContactRatingsTable />
        </LoggedInView>
    );

}